module.exports = __webpack_public_path__ + "img/chr_ts_3.86a8b53c.png";